import { useApi } from "..";
import { LoginRequest } from "./interfaces/login.request";
import { LoginResponse } from "./interfaces/login.response";

export const useLoginService = () => {
  const { get, post, put } = useApi();

  const postLogin = async ({ body }: LoginRequest) => {
    const { data } = await post<LoginResponse>("/user/login", body);
    return data;
  };

  const postAutoLogin = async ({ body }: { body: { phone: string } }) => {
    const { data } = await post<LoginResponse>("/user/auto-login", body);
    return data;
  };

  const putLogout = async () => {
    return put("/user/logout");
  };

  const getMe = async () => {
    const { data } = await get("/user/me");
    return data;
  };

  const putUpdateUser = async (
    id: number,
    body: { name?: string; email?: string; phone?: string }
  ) => {
    const { data } = await put(`/user/update/${id}`, body);
    return data;
  };

  const putUpdatePassword = async (
    id: number,
    body: { currentPassword: string; newPassword: string }
  ) => {
    const { data } = await put(`/user/pass/${id}`, body);
    return data;
  };

  return {
    postLogin,
    putLogout,
    postAutoLogin,
    getMe,
    putUpdateUser,
    putUpdatePassword,
  };
};
